import { FormDataModel } from '@/model/FormModel'
import { payTypeList } from '@/utils/index'

export const FromFieldData: FormDataModel[] = [
  {
    title: '联系人信息',
    type: 1,
    labelClass: 'yellow',
    labelName: '联',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '姓名',
        placeholder: '',
        value: '',
        rules: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'sex',
        fieldName: '性别',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'Sex',
          pickerType: '',
          filterable: true,
          selectType: 1// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'email',
        fieldName: '邮箱',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'phone',
        fieldName: '联系电话',
        placeholder: '',
        value: '',
        rules: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'post',
        fieldName: '岗位',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'dept',
        fieldName: '部门',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-cascader-provinces',
        componentName: '省市区级联',
        fieldKey: 'address',
        fieldName: '省市县',
        placeholder: '',
        value: [],
        rules: [{
          required: false,
          message: '',
          trigger: 'change'
        }],
        option: [],
        config: {
          isDisabled: false,
          multiple: true,
          clearable: true,
          filterable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'addressDetail',
        fieldName: '详细地址',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'mark',
        fieldName: '备注',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }
    ]
  }, {
    title: '账户信息',
    type: 2,
    labelClass: 'blue',
    labelName: '账',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'accounts',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: [
          {
            componentType: 'el-select',
            componentName: '下拉选择',
            fieldKey: 'type',
            fieldName: '支付类型',
            placeholder: '',
            value: '',
            rules: [{
              required: true,
              message: '请填写必填项',
              trigger: 'change'
            }],
            option: payTypeList,
            config: {
              isDisabled: false,
              multiple: false,
              clearable: true,
              uniqueFieldKey: 'companyConcatPayType',
              isHide: false,
              selectType: 3// 1本地2远程
            }
          },
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'name',
            fieldName: '公司全称',
            placeholder: '',
            value: '',
            rules: [{
              required: true,
              message: '请填写必填项',
              trigger: 'change'
            }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              isHide: true
            }
          },
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'no',
            fieldName: '银行账号',
            placeholder: '',
            value: '',
            rules: [{
              required: true,
              message: '请填写必填项',
              trigger: 'change'
            }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              isHide: true
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'bank',
            fieldName: '开户行',
            placeholder: '',
            value: '',
            rules: [{
              required: true,
              message: '',
              trigger: 'change'
            }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              isHide: true
            }
          }
        ]
      }
    ]
  }
]
